module.exports = __webpack_public_path__ + "img/compasiaLogo.43a8d61c.png";